import AjaxInvitationService from './ajax-invitation-service'

class BuildingRuleService extends AjaxInvitationService {

  getList(building_id = null, invitationCode) {
    let data = (building_id ? { building_id:building_id, appointment:1} : null),
    headers = this.getInvitationHeader(invitationCode)

    return this.makeGetRequest('/by-invitation/building-rules', data, headers)
  }

  agree(data) {
    let headers = this.getInvitationHeader(data.code)
    return this.makePostRequest('/by-invitation/building-rules/agree', data, headers)
  }

}

const _instance = new BuildingRuleService()
export default _instance